import { render } from "./FiltersResults.vue?vue&type=template&id=aba44a84"
import script from "./FiltersResults.vue?vue&type=script&lang=js"
export * from "./FiltersResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__